import { Component, Input } from '@angular/core';
import { IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IEquityMovementScheduleFinancialTableData } from '../../../interfaces/pdf-tron/equity-movement-schedule-financial-table-data.interface';

@UntilDestroy()
@Component({
    selector: 'aumico-annualReport-equity-movement-german-display-component',
    templateUrl: 'equity-movement-schedule-german-display.component.html',
    styleUrls: ['equity-movement-schedule-german-display.component.scss'],
})
export class EquityMovementScheduleGermanDisplayComponent {
    readonly maxFlisLengthForBigFontSize = 4;

    @Input() rows: IEquityMovementScheduleFinancialTableData[] = [];

    @Input() columnNames: string[] = [];

    @Input() styleOptions: IStyleOptions | undefined;
}
